import * as React from 'react';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';

const CustomMenuItem = React.forwardRef((props, ref) => {
    return <MenuItem ref={ref} {...props} />;
});

export { CustomMenuItem as MenuItem };
